import {Action} from '@ngrx/store';
import {Shift} from '@app/core/models/shift.model';
import {Pagination} from '@app/core/models/pagination.model';
import {IQOPagination} from '@quickorder/angular-web-lib/lib/types/interfaces/q-o-pagination.interface';

export enum EActionsActions {
	GetShiftsPendingApproval = '[Actions] Get Actions',
	GetShiftsPendingApprovalSuccess = '[Actions] Get Actions Success',
	ApproveShifts = '[Actions] Approve Shifts',
	ApproveShiftsSuccess = '[Actions] Approve Shifts Success',
	DeleteShifts = '[Actions] Delete Shifts',
	DeleteShiftsSuccess = '[Actions] Delete Shifts Success',

	// New design
	GetShiftRequests = '[Actions] Get Shift Requests',
	GetShiftRequestsSuccess = '[Actions] Get Shift Requests Success',
	ApproveShiftRequest = '[Actions] Approve Shift Request',
	ApproveShiftRequestSuccess = '[Actions] Approve Shift Request Success',
	RemoveShiftRequest = '[Actions] Remove Shift Request',
	RemoveShiftRequestSuccess = '[Actions] Remove Shift Request Success',
	GetShiftSwapRequests = '[Actions] Get Shift Swap Requests',
	GetShiftSwapRequestsSuccess = '[Actions] Get Shift Swap Requests Success',
}

export class GetShiftsPendingApproval implements Action {
	public readonly type = EActionsActions.GetShiftsPendingApproval;

	constructor(public department_id: number, public filter: { only_include_payment_period: boolean }, public page_size: number = 200, public page: number = 1) {
	}
}

export class GetShiftsPendingApprovalSuccess implements Action {
	public readonly type = EActionsActions.GetShiftsPendingApprovalSuccess;

	constructor(public shifts: Shift[], public pagination: Pagination) {
	}
}

export class ApproveShifts implements Action {
	public readonly type = EActionsActions.ApproveShifts;

	constructor(public payload: { id: number, start_date: string, start_time: string, end_time: string, pause: number }[]) {
	}
}

export class ApproveShiftsSuccess implements Action {
	public readonly type = EActionsActions.ApproveShiftsSuccess;

	constructor(public ids: number[]) {
	}
}

export class DeleteShifts implements Action {
	public readonly type = EActionsActions.DeleteShifts;

	constructor(public payload: { id: number }[]) {
	}
}

export class DeleteShiftsSuccess implements Action {
	public readonly type = EActionsActions.DeleteShiftsSuccess;

	constructor(public ids: number[]) {
	}
}

export class GetShiftRequests implements Action {
	public readonly type = EActionsActions.GetShiftRequests;

	constructor(public page: number, public page_size: number = 20) {
	}
}

export class GetShiftRequestsSuccess implements Action {
	public readonly type = EActionsActions.GetShiftRequestsSuccess;

	constructor(public shifts: Shift[], public pagination: IQOPagination) {
	}
}

export class ApproveShiftRequest implements Action {
	public readonly type = EActionsActions.ApproveShiftRequest;

	constructor(public shift: Shift, public userId: number) {
	}
}

export class ApproveShiftRequestSuccess implements Action {
	public readonly type = EActionsActions.ApproveShiftRequestSuccess;

	constructor(public shift: Shift) {
	}
}

export class RemoveShiftRequest implements Action {
	public readonly type = EActionsActions.RemoveShiftRequest;

	constructor(public shift: Shift) {
	}
}

export class RemoveShiftRequestSuccess implements Action {
	public readonly type = EActionsActions.RemoveShiftRequestSuccess;

	constructor(public shift: Shift) {
	}
}

export class GetShiftSwapRequests implements Action {
	public readonly type = EActionsActions.GetShiftSwapRequests;

	constructor(public page: number, public page_size: number = 20) {
	}
}

export class GetShiftSwapRequestsSuccess implements Action {
	public readonly type = EActionsActions.GetShiftSwapRequestsSuccess;

	constructor(public shifts: Shift[], public pagination: IQOPagination) {
	}
}

export type ActionsActions =
	GetShiftsPendingApproval |
	GetShiftsPendingApprovalSuccess |
	ApproveShifts |
	ApproveShiftsSuccess |
	DeleteShifts |
	DeleteShiftsSuccess |
	GetShiftRequests |
	GetShiftRequestsSuccess |
	ApproveShiftRequest |
	ApproveShiftRequestSuccess |
	RemoveShiftRequestSuccess |
	RemoveShiftRequest |
	GetShiftSwapRequests |
	GetShiftSwapRequestsSuccess
	;
